export default {
    "REGION": "eu-central-1",
    "USER_POOL_ID": "eu-central-1_AlpE5Rpni",
    "USER_POOL_APP_CLIENT_ID": "52trbjq07uljt54a8rqv84ha2h"
}
